import React from "react";
import { Link } from "react-router-dom";
import EntityLinkDTO from "../dtos/EntityLinkDTO";
import styles from "./contractlink.module.scss";
import { getContractDetailRoute } from 'features/shared/helpers/routeHelper';

interface Props {
  entityLink: EntityLinkDTO;
  smallText?: boolean;
  className?: string;
  isFuelingContract?: boolean;
}

const ContractLink = ({ entityLink, smallText = true, className, isFuelingContract }: Props) => {
  return (
    <Link
      className={`text-truncate ${styles.link}${smallText ? " small" : ""}${className ? " " + className : ""}`}
      to={getContractDetailRoute(entityLink.entityId!, isFuelingContract)}
    >
      {entityLink.customName ? entityLink.customName : entityLink.name}
    </Link>
  );
};

export default ContractLink;
